<template>
  <el-aside class="right" :class="{ 'open': showContent, 'disabled': isPreview }" :width="sidebarWidth">
    <div class="content">
      <div v-show="showTab(tab) && activeItem === tab.key" v-for="tab in tabs" :is="tab.key" :key="tab.key" />
    </div>
    
    <el-menu class="menubar" @select="selectMemuItem" :collapse="true">
      <el-menu-item v-for="tab in tabs" v-show="showTab(tab)" :index="tab.key" :key="tab.key">
        <i :class="tab.icon"></i>
        <span slot="title">
          {{ tab.name }}
        </span>
      </el-menu-item>
    </el-menu>
    
  </el-aside>
</template>

<script>
  import Texts from './RightSidebar/Texts.vue';
  import Quotes from './RightSidebar/Quotes.vue';
  import Rhyme from './RightSidebar/Rhyme.vue';
  import Format from './RightSidebar/Editor.vue';
  import Images from './RightSidebar/Images.vue';
  import Layers from './RightSidebar/Layers.vue';
  import Qrcode from './RightSidebar/Qrcode.vue';
  import Backgrounds from './RightSidebar/Backgrounds.vue';
  import { mapGetters } from 'vuex';
  import Editor from '../classes/Editor'

  export default {
    data() {
      return {
        showContent: false,
        activeItem: 'format',
        tabs: [
          { name: 'Formatowanie', key: 'format', icon: 'el-icon-s-operation', forceShow: true },
          { name: 'Tła', key: 'backgrounds', icon: 'el-icon-picture-outline' },
          { name: 'Obrazki', key: 'images', icon: 'el-icon-picture-outline' },
          { name: 'Teksty', key: 'texts', icon: 'el-icon-edit' },
          { name: 'Cytaty', key: 'quotes', icon: 'el-icon-chat-line-round' },
          { name: 'Rymy', key: 'rhyme', icon: 'el-icon-chat-line-square' },
          { name: 'Qrcode', key: 'qrcode', icon: 'el-icon-full-screen' },
        ]
      }
    },
    computed: {
      ...mapGetters('user', [
        'loggedIn',
      ]),
      ...mapGetters('creator', [
        'version',
        'isPreview'
      ]),
      isMobile() {
        return window.innerWidth < 1024
      },
      sidebarWidth() {
        return this.isMobile ? '100%' : '400px'
      }
    },
    mounted() {
      Editor.addCallback(['selection:created', 'selection:updated'], () => {
        this.selectMemuItem(this.getTabByType(Editor.canvas.getActiveObject().type))
      })
      Editor.addCallback(['selection:cleared'], () => this.selectMemuItem(null))
    },
    methods: {
      getTabByType(objectType) {
        switch(objectType) {
          case 'text':
          case 'textbox':
            return 'format'
          case 'image':
            return 'images'
        }
      },
      showTab(tab) {

        if (this.loggedIn || tab.forceShow) {
          return true;
        }

        if (! (this.version && this.version.tabs)) {
          return false;
        }

        return this.version.tabs.find((name) => name == tab.key);
      },
      selectMemuItem(menuItem) {
        this.activeItem = menuItem
      }
    },
    components: {
      Qrcode,
      Rhyme,
      Texts,
      Format,
      Images,
      Quotes,
      Layers,
      Backgrounds
    }
  }
</script>

<style lang="less" scoped>
  .rightToggle {
    background: #fff;
    color: #222;
    text-align: center;
    padding: 5px;
    @media (min-width: 1024px) {
      display: none;
    }
  }
  .right {
    @media (max-width: 1023px) {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #fff;
      width: 100%;
      padding: 0;
      box-sizing: border-box;
      box-shadow: 0 0 10px rgba(0, 0, 0, .3);
    }

    @media (min-width: 1024px) {
      width: 400px;
      background: #fff;
      max-height: 100vh;
      display: flex;
      flex-direction: row;
      padding-right: 0;
    }

    &.mobile {
      position: fixed;
      bottom: 0;
      width: 100vw;
      left: 0;
      transform: translateY(calc(100% - 80px));
      transition: transform .4s;
      &.open {
        transform: translateY(0);
      }
    }
    &.disabled {
      opacity: .3;
      pointer-events: none;
    }
  }
  .content {
    @media (max-width: 1023px) {
      max-height: 150px;
      overflow: auto;
      padding: 0 20px;
    }

    overflow: auto;
    width: 100%;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .el-collapse-item__content {
    .el-row + .el-row {
      margin-top: 10px;
    }
  }
  .menubar {
    display: flex;
    background: #f7f7f7;
    border-left: 1px solid #ebeaea;

    @media (max-width: 1023px) {
      box-shadow: 0 0 10px rgba(0, 0, 0, .3);
      width: 100%;
      border: 0;
    }

    @media (min-width: 1024px) {
      flex-direction: column;
      justify-content: center;
    }
  }
  .el-menu-item {
    padding: 0 30px !important;
  }
</style>